import { TChallengeWorkoutStatus } from '../challenge/types';
import { CHALLENGE_LIST_SIZE } from './constants';

export function getCurrentProgressPage(challengeProgress: TChallengeWorkoutStatus[]) {
  const challengeLength = challengeProgress.length;
  const todaysStatusIndex = challengeProgress.findIndex(
    (status) => status === 'current' || status === 'current-completed' || status === 'final-completed'
  );
  const index = todaysStatusIndex === challengeLength - 1 ? todaysStatusIndex - 1 : todaysStatusIndex;
  return Math.ceil((index + 1) / CHALLENGE_LIST_SIZE);
}

export function getChallengeButtonLabelPostfix(
  hasPartaken: boolean,
  hasCompletedToday: boolean,
  isFirstDayOfChallenge: boolean,
  isLastDayOfChallenge: boolean
) {
  if (isLastDayOfChallenge && hasCompletedToday) {
    return 'Congrats';
  } else if (hasCompletedToday) {
    return 'ComeBackTomorrow';
  } else if (hasPartaken) {
    return 'StartDailyChallenge';
  } else if (isFirstDayOfChallenge) {
    return 'NotStarted';
  } else {
    return 'Started';
  }
}
